import { render } from "./ListView.vue?vue&type=template&id=08a1634e&scoped=true"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=08a1634e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08a1634e"

export default script